import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Toaster } from "react-hot-toast";

// Pages
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import AdminUsers from "./pages/admin/userApprovals";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import RegistrationPending from "./pages/approvalPending";
import UnauthorizedScreen from "./pages/UnauthorizedScreen";
import Profile from "./pages/User/Profile";
import Settings from "./pages/Settings";
import AdminChangePassword from "./pages/admin/settings";


import EyeHealthAnalyzer from "./pages/User/eyeAnalyzer";
import UserDashboard from "./pages/User/Dashboard";
import AdminDashboard from "./pages/admin/Dashboard";


// Layout
import DashboardLayout from "./Layouts/dashboardLayout";
import ProtectedRoutes from "./Layouts/ProtectedRoutes";
import AdminRoute from "./Layouts/AdminRoute";
import PublicRoute from "./Layouts/PublicRoutes";
import AdminReports from "./pages/admin/AdminReports";



function App() {
  return (
    <Router>
      <div className="App">
        <Toaster position="top-center" reverseOrder={false} />
        <ToastContainer />

        <Routes>
          <Route index element={<Navigate to="/login" replace />} />
          {/* Public Routes */}
          <Route element={<PublicRoute />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/approval-pending" element={<RegistrationPending />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route
              path="/reset-password/:token"
              element={<ResetPasswordPage />}
            />
          </Route>

          {/* Private Routes */}
          <Route element={<ProtectedRoutes />}>
            <Route element={<DashboardLayout />}>
              <Route path="/user/dashboard" element={<UserDashboard />} />
              <Route path="/user/analyzer" element={<EyeHealthAnalyzer />} />
              <Route path="/user/profile" element={<Profile />} />  
              <Route path="/user/settings" element={<Settings />} />  

              {/* Private Admin Routes */}
              <Route element={<AdminRoute />}>
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/users" element={<AdminUsers />} />
                <Route path="/admin/reports" element={<AdminReports />} />  
                <Route path="/admin/settings" element={<AdminChangePassword />} />  
              </Route>
            </Route>
          </Route>

          <Route path="/unauthorized" element={<UnauthorizedScreen />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
